import { types } from 'mobx-state-tree';
import Actions from './Actions';
const RevenueRangeProps = {
    max: types.optional(types.maybeNull(types.number), null),
    min: types.optional(types.maybeNull(types.number), null),
    string: types.optional(types.string, ''),
};
const RevenueRange = types.model(RevenueRangeProps).actions(Actions);
export default RevenueRange;
